import MultipleInputSkeleton from './MultipleInputSkeleton'

export const PersonalSkeleton = () => <MultipleInputSkeleton count={6} />

export const PersonalFormSkeleton = () => <MultipleInputSkeleton count={5} />

export const HouseholdSkeleton = () => <MultipleInputSkeleton count={3} />

export const IncomeAllSkeleton = () => <MultipleInputSkeleton count={4} />

export const EmploymentPositionSkeleton = () => (
  <MultipleInputSkeleton count={2} />
)

export const ExpensesSkeleton = () => <MultipleInputSkeleton count={11} />

export const KfzFormSkeleton = () => <MultipleInputSkeleton count={8} />

export const LoanPayoutSkeleton = () => <MultipleInputSkeleton count={4} />

export const PayoutAccountSkeleton = () => <MultipleInputSkeleton count={3} />

export const PropertySkeleton = () => <MultipleInputSkeleton count={2} />

export const AddressSkeleton = () => <MultipleInputSkeleton count={4} />
